import { apiCall } from "./ApiCallBase";
import { API_CONFIG } from "../shared/constants"

export interface DTCListResponse {
    dtcs: DTCItem[];
}

export interface DTCItem {
    dtcId: string;
    dtc: string;
    dtcDescription: string;
}

export async function getDTCList(){
    const url = `${API_CONFIG.BASE_URL}/dtc`
    const headers = {
        "Authorization": `${API_CONFIG.AUTH}`,
        "Content-Type": "application/json",
    };
    return await apiCall<DTCListResponse>(url, headers);
}

export async function getDTCListWithQuery(query: string){
    const url = `${API_CONFIG.BASE_URL}/dtc?q=${query}`

    const headers = {
        "Authorization": `${API_CONFIG.AUTH}`,
        "Content-Type": "application/json",
    };
    return await apiCall<DTCListResponse>(url, headers);
}

